import React, {useEffect, useId, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import SimpleGrid from "../../../../../components/SimpleGrid.jsx";
import SeeMore from "../../../../../components/SeeMore.jsx";
import {useRenderNumber} from "../../../../../api/utilities/useValueRenderers.js";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";
import toast from "react-hot-toast";

export default function DailyCouponPerformance({title, day, project}) {
    let id = useId();
    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let [data, setData] = useState(null);
    let workerConfig = useAuthorityConfiguration();
    let [dataSource, setDataSource] = useState([]);
    let renderNumber = useRenderNumber();
    let dayKey = day.format('YYYY-MM-DD');

    useEffect(() => {
        let active = true;
        setData(null);
        setDataSource([]);

        new ErpCalculationApi(workerConfig)
            .dailyCouponPerformance({
                projectId: project.id,
                dayInput: {
                    day: dayKey,
                }
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
            })
            .catch(e => {
                if (!active) {
                    return;
                }

                et(e).then((message) => { if (message) toast.error(message); });
            });

        return () => {
            active = false;
        };
    }, [dayKey, project.id]);

    let columns = [
        t('orders.coupon'),
        t('orders.amount'),
    ];

    let columnClasses = [
        'text-left',
        'text-right whitespace-nowrap',
    ];

    useEffect(() => {
        let newDataSource = [];

        for (let couponStats of (data ?? [])) {
            newDataSource.push([
                couponStats.coupon,
                renderNumber(couponStats.amount),
            ]);
        }

        setDataSource(newDataSource);
    }, [data]);

    return (
        <LoadingComponent
            loading={data === null}
            className={'col-span-12 sm:col-span-6 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox inline-flex flex-col w-full rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                <div className={'p-3'}>
                    <SeeMore heightClass={'h-32'}>
                        <SimpleGrid
                            columns={columns}
                            dataSource={dataSource}
                            columnClasses={columnClasses}
                        />
                    </SeeMore>
                </div>
            </div>
        </LoadingComponent>
    );
}
